import {ComponentBase} from '../component-base';

class LastTouchOffset {

  private offsetX = 0;
  private offsetY = 0;

  copyFromEvent(e: MouseEvent) {
    this.offsetX = e.offsetX;
    this.offsetY = e.offsetY;
  }

  copyToEvent(e) {
    e.offsetX = this.offsetX;
    e.offsetY = this.offsetY;
  }
}

export class TouchAndMouseMap extends ComponentBase {

  private _isTouchStartInvoked;
  private _isTouchEndInvoked;
  private _isTouchMoveInvoked;
  private _lastTouchOffset;

  constructor() {
    super();
    this._isTouchStartInvoked = false;
    this._isTouchEndInvoked = false;
    this._isTouchMoveInvoked = false;
    this._lastTouchOffset = new LastTouchOffset();
  }

  static setOffsetXYToEvent(e) {
    const rect = e.target.getBoundingClientRect();
    const firstTouch = e.targetTouches[0];
    e.offsetX = firstTouch.pageX - rect.left;
    e.offsetY = firstTouch.pageY - rect.top;
  }

  mouseDown(e) {
    if (!this._isTouchStartInvoked) {
      return this.hold(e);
    }
    this._isTouchStartInvoked = false;
  }

  /** Для наследников (размещение объектов): тач без немедленного `hold()` — см. ObjectAddService. */
  protected beginTouchFromCanvas(e: TouchEvent): void {
    this._isTouchStartInvoked = true;
    TouchAndMouseMap.setOffsetXYToEvent(e);
    this._lastTouchOffset.copyFromEvent(e as any);
  }

  touchStart(e) {
    this.beginTouchFromCanvas(e);
    return this.hold(e);
  }

  mouseUp(e) {
    if (!this._isTouchEndInvoked) {
      return this.release(e);
    }
    this._isTouchEndInvoked = false;
  }

  touchEnd(e) {
    this._isTouchEndInvoked = true;
    this._lastTouchOffset.copyToEvent(e);
    return this.release(e);
  }

  touchMove(e) {
    e.preventDefault();
    this._isTouchMoveInvoked = true;
    TouchAndMouseMap.setOffsetXYToEvent(e);
    this._lastTouchOffset.copyFromEvent(e);
    return this.move(e);
  }

  mouseMove(e) {
    if (!this._isTouchMoveInvoked) {
      return this.move(e);
    }
    this._isTouchMoveInvoked = false;
  }

  hold(e) {
  }

  release(e) {
  }

  move(e) {
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/touch-and-mouse-map.ts